<div class="col p-0">
  @if (timelineData) {
    <div class="row d-flex align-items-center">
      <span class="" [ngClass]="!isDownloadComponentActive ? 'f-22 _500 ms-2' : 'f-22 _500'">{{
        'summary' | translate
      }}</span>
    </div>
    <div class="row" [style.max-height]="'80px'" [style.min-height]="'67px'">
      <div class="col-3 border-top border-right p-0">
        <div
          ><span class="f-12 _700">{{ 'Product Campaign Name' | translate }}</span></div
        >
        <div
          ><span class="f-18 _400">{{ timelineData.name }}</span></div
        >
      </div>
      <div class="col-3 border-top border-right">
        <div
          ><span class="f-12 _700">{{ 'Axe' | translate }}</span></div
        >
        <div
          ><span class="f-18 _400">{{ workspaceName }}</span></div
        >
      </div>
      @if (!!timelineData.description) {
        <div class="col-6 border-top">
          <div
            ><span class="f-12 _700">{{ 'Description' | translate }}</span></div
          >
          <div
            ><span class="f-18 _400">{{ timelineData.description }}</span></div
          >
        </div>
      }
      @if (!timelineData.description) {
        <div class="col-6 border-top">
          <div
            ><span class="f-12 _700 text-uppercase">{{ 'campaignLeader' | translate }}</span></div
          >
          <div>
            <div class="d-flex justify-content-start align-items-center">
              <div class="row ms-1 d-flex">
                @for (user of timelineData?.projectLeaders; track $index) {
                  <div class="user-avatar" [style.z-index]="$index + 1" [style.left]="`${-1 * ($index * 8)}px`">
                    <mtm-user-profile-picture
                      placement="left"
                      container="body"
                      [ngbTooltip]="selectedParticipantTooltip"
                      [username]="user"
                      [height]="24"
                      [width]="24">
                    </mtm-user-profile-picture>
                    <ng-template #selectedParticipantTooltip>
                      <div class="user-tooltip d-flex flex-column align-items-start p-1">
                        <h6 class="user-name m-0">{{ getUserInfo(user) }}</h6>
                      </div>
                    </ng-template>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="row" [style.max-height]="'80px'" [style.min-height]="'67px'">
      <div class="col-3 border-bottom border-top border-right p-0">
        <div
          ><span class="f-12 _700">{{ 'Product Campaign' | translate }}</span></div
        >
        <div
          ><span class="f-18 _400">{{ summaryDetail['Project Type'] || 'NA' | translate }}</span></div
        >
      </div>
      <div class="col-3 border-bottom border-top border-right">
        <div
          ><span class="f-12 _700">{{ 'Type of Campaign' | translate }}</span></div
        >
        <div
          ><span class="f-18 _400">{{ summaryDetail['Campaign Type'] || 'NA' | translate }}</span></div
        >
      </div>
      <div class="col border-bottom border-top">
        <div>
          <span class="f-12 _700">{{ 'Type of Product' | translate }}</span>
        </div>
        <div
          ><span class="f-18 _400">{{ summaryDetail['Product Category'] || 'NA' | translate }}</span></div
        >
      </div>
      @if (!!timelineData.description) {
        <div class="col-3 border-bottom border-top border-left">
          <div
            ><span class="f-12 _700 text-uppercase">{{ 'campaignLeader' | translate }}</span></div
          >
          <div>
            <div class="d-flex justify-content-start align-items-center">
              <div class="row ms-1 d-flex">
                @for (user of timelineData?.projectLeaders; track $index) {
                  <div class="user-avatar" [style.z-index]="$index + 1" [style.left]="`${-1 * ($index * 8)}px`">
                    <mtm-user-profile-picture
                      placement="left"
                      container="body"
                      [ngbTooltip]="selectedParticipantTooltip"
                      [username]="user"
                      [height]="24"
                      [width]="24">
                    </mtm-user-profile-picture>
                    <ng-template #selectedParticipantTooltip>
                      <div class="user-tooltip d-flex flex-column align-items-start p-1">
                        <h6 class="user-name m-0">{{ getUserInfo(user) }}</h6>
                      </div>
                    </ng-template>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="row" [style.max-height]="'80px'" [style.min-height]="'67px'">
      <div class="col-3 border-bottom border-right">
        <div class="row">
          @if (!!assetListCriteria['Asset Bundle']) {
            <div class="col-3 p-0">
              <span class="f-12 _700">{{ 'Asset List' | translate }}</span>
            </div>
          }
        </div>
        <div class="row">
          @if (!!assetListCriteria['Asset Bundle']) {
            <div class="col-3 p-0">
              @if (
                assetListCriteria['Asset Bundle'] === '1 Star' ||
                assetListCriteria['Asset Bundle'] === '2 Star' ||
                assetListCriteria['Asset Bundle'] === '3 Star'
              ) {
                <i class="fa fa-star ms-2 rating-start" aria-hidden="true"></i>
              }
              @if (assetListCriteria['Asset Bundle'] === '2 Star' || assetListCriteria['Asset Bundle'] === '3 Star') {
                <i class="fa fa-star ms-1 rating-start" aria-hidden="true"></i>
              }
              @if (assetListCriteria['Asset Bundle'] === '3 Star') {
                <i class="fa fa-star ms-1 rating-start" aria-hidden="true"></i>
              }
            </div>
          }
        </div>
      </div>
      <div class="col border-bottom border-right">
        <div
          ><span class="f-12 _700">{{ 'Product Subcategory' | translate }}</span></div
        >
        <div
          ><span class="f-18 _400">{{ summaryDetail['Product Subcategory'] || 'NA' }}</span></div
        >
      </div>
      <div class="col-6 border-bottom">
        <div
          ><span class="f-12 _700">{{ 'MAD' | translate }}</span></div
        >
        <div
          ><span class="f-18 _500">{{
            timelineData.expectedMad ? (getFormatedDate(timelineData.expectedMad) | ngbDate) : ('NA' | translate)
          }}</span></div
        >
      </div>
    </div>
    @if (summaryDetail['Project Type'] === 'Hallmarks') {
      <div class="row mt-2">
        @if (summaryDetail['Hallmarks Xmas']) {
          <div class="d-flex align-items-center">
            <div>
              <span class="f-12 _400">{{ 'xmas' | translate }}</span>
            </div>
            <div class="ms-3">
              <span class="f-12 _700">{{ summaryDetail['Hallmarks Xmas'] | translate }}</span>
            </div>
          </div>
        }
        <div class="d-flex align-items-center ms-3">
          <div>
            <span class="f-12 _400">{{ 'chinaSpecific' | translate }}</span>
          </div>
          <div class="ms-3">
            <span class="f-12 _700">{{ summaryDetail['China Specific'] | translate }}</span>
          </div>
        </div>
        <div class="d-flex align-items-center ms-3">
          <div>
            <span class="f-12 _400">{{ 'posm' | translate }}</span>
          </div>
          <div class="ms-3">
            <span class="f-12 _700">{{ summaryDetail['POSM'] | translate }}</span>
          </div>
        </div>
      </div>
    }
  }
</div>
